import React from 'react';
import { useDispatch } from 'react-redux';
import Icon from '../common/icon';
import PdfPreview from '../pdfPreview';
import { previewFile } from '../../store/page/actions';
import { getFileExtension } from '../../utils/utils';
import { FileProps } from '../../types/common-types';
import './style.scss';

interface Props {
  file: FileProps;
}
const FilePreview: React.FC<Props> = ({ file }) => {
  const { path, name, mimeType } = file;
  const dispatch = useDispatch();
  const onClose = () => {
    dispatch(previewFile());
  };
  const fileExtension = getFileExtension(name);
  const renderFile = () => {
    if (mimeType.indexOf('image') !== -1) {
      return <img id="preview" src={path} alt="preview" />;
    }
    if (fileExtension === 'pdf') {
      return <PdfPreview title={name} src={path} />;
    }
    return (
      <div styleName="preview__file">
        <Icon value="picture" />
      </div>
    );
  };
  return (
    <div
      styleName="preview"
      role="button"
      tabIndex={0}
      onKeyPress={() => {
        onClose();
      }}
      onClick={onClose}
    >
      <div styleName="preview__header">
        <div styleName="preview__header__title">
          <div
            styleName="preview__actions__icon"
            role="button"
            tabIndex={0}
            onKeyPress={() => {
              onClose();
            }}
            onClick={onClose}
          >
            <Icon value="close" />
          </div>
          <div styleName="preview__title">{name}</div>
        </div>
        <div styleName="preview__actions" />
      </div>
      {renderFile()}
    </div>
  );
};
export default FilePreview;
